// extracted by mini-css-extract-plugin
export default {"collabBanner":"styles_collabBanner__aENaO","rocket":"styles_rocket__MDOnd","pattern":"styles_pattern__7-Apk","button":"styles_button__W2WcY","arrow":"styles_arrow__wY0Ib"};